import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Select from 'react-select';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { Tabs, Tab } from 'react-bootstrap';
import { AdvertiserApi } from '../../../api';
import { findPredicate } from '../../../utils/helpers/filter_conversions';
import { Spinner, StatBar, DateRange } from '../../common/';
import { calendarRanges } from '../../../utils/helpers/calendar_ranges';
import { ButtonExport } from '../../common/buttons';
import { convertMillsToDollars } from '../../../utils/helpers/currency';

class CustomDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 'text',
    };
  }

  componentDidMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    if (this.props.account.uuid) {
      const { dispatch } = this.props;
      const data = { ...params, id: this.props.account.uuid, account_id: this.props.account.uuid };
      const campaignData = {
        id: data.id,
        account_id: data.account_id,
        page: data.page,
        per_page: data.per_page,
        sort: data.sort,
      };
      dispatch(AdvertiserApi.actions.reports.get(data));
      dispatch(AdvertiserApi.actions.reportsSummary.get(data));
      dispatch(AdvertiserApi.actions.campaigns.get(campaignData));
    }
  }

  handleOnFilterChange(e) {
    const filters = get(this.props, 'reports.meta.filters', {});
    Object.entries(e).forEach(([field, properties]) => {
      switch (properties.type) {
        case 'NumberFilter': {
          const {
            value: { comparator, number },
          } = properties;
          filters[field] = { value: number, predicate: findPredicate(comparator) };
          break;
        }
        case 'SelectFilter': {
          const { value } = properties;
          filters[field] = { value };
          break;
        }
        default:
          break;
      }
    });

    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 10),
      filters,
      sort: get(this.props, 'reports.meta.sort', {}),
    });
  }

  handleOnSortChange(field, order) {
    const sort = { field, order };
    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 10),
      filters: get(this.props, 'reports.meta.filters', {}),
      sort,
    });
  }

  handleOnPageChange(page, per_page) {
    this.fetchResource({
      page,
      per_page,
      filters: get(this.props, 'reports.meta.filters', {}),
      sort: get(this.props, 'reports.meta.sort', {}),
    });
  }

  handleDateApply(d) {
    const filters = get(this.props, 'reports.meta.filters', {});

    filters.daterange = {
      start_date: { value: d.startDate.format() },
      end_date: { value: d.endDate.format() },
    };

    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 10),
      filters,
      sort: get(this.props, 'reports.meta.sort', {}),
    });
  }

  render() {
    const { reports, isLoading, account, reportsSummary, summaryIsLoading, campaigns, campaignsIsLoading } = this.props;
    const { data: rawData, meta } = reports || {};
    const { pagination, sort } = meta || {};

    const totalData = rawData || [];

    const data = totalData.filter(item => {
      return item.ad_format === this.state.key;
    });

    const sd = get(meta, 'filters.daterange.start_date.value', moment().startOf('month').toISOString());
    const ed = get(meta, 'filters.daterange.end_date.value', moment().endOf('month').toISOString());

    const daterange = { start_date: sd, end_date: ed };

    const totalCount = get(pagination, 'total_count', 35);
    const perPageList = [
      { text: '10', value: 10 },
      { text: '20', value: 20 },
      { text: '30', value: 30 },
      { text: 'All', value: totalCount },
    ];

    const ExportCSVButton = onClick => {
      return <ButtonExport className="m-b-sm" btnLabel="Export to CSV" onClick={onClick} />;
    };

    const campaignSummary = () => {
      let value = '0.00';
      if (campaigns.data) {
        value = campaigns.data.find(campaign => !campaign.is_open)
          ? convertMillsToDollars(campaigns.data.reduce((total, { budget }) => total + budget, 0))
          : 'Open';
      }
      return value;
    };

    const options = {
      exportCSVBtn: ExportCSVButton,
      onFilterChange: this.handleOnFilterChange.bind(this),
      onSortChange: this.handleOnSortChange.bind(this),
      sortName: get(sort, 'field', 'day'),
      sortOrder: get(sort, 'order', 'asc'),
      defaultSortName: get(sort, 'field', 'day'),
      defaultSortOrder: get(sort, 'order', 'asc'),
      sizePerPage: get(pagination, 'per_page', 10),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: perPageList,
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1),
    };

    const fetchInfo = {
      dataTotalSize: totalCount || 0,
    };

    const colSum = (tableData, field, dataType) => {
      if (account.pixel_status === 'pixel_inactive' && field === 'conversions') {
        return '-';
      }

      let label = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        label += parseFloat(tableData[i][field]);
      }
      return <strong>{dataType === 'integer' ? parseInt(label, 10) : label.toFixed(2)}</strong>;
    };

    const colAvg = (tableData, field, ac = 'spend') => {
      if (account.pixel_status === 'pixel_inactive' && field === 'conversions') {
        return '-';
      }

      let sp = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        sp += parseFloat(tableData[i][ac]);
      }

      let typeVal = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        typeVal += parseFloat(tableData[i][field]);
      }

      const label = typeVal === 0 ? 0 : sp / typeVal;

      return <strong>{label.toFixed(2)}</strong>;
    };

    const footerData = [
      [
        {
          label: 'Total',
          columnIndex: 0,
        },
        {
          columnIndex: 4,
          align: 'left',
          formatter: e => colSum(e, 'spend'),
        },
        {
          columnIndex: 5,
          align: 'left',
          formatter: e => colSum(e, 'video_spend'),
        },
        {
          columnIndex: 6,
          align: 'left',
          formatter: e => colSum(e, 'total_spend'),
        },
        {
          columnIndex: 7,
          align: 'left',
          formatter: e => colSum(e, 'clicks', 'integer'),
        },
        {
          columnIndex: 8,
          align: 'left',
          formatter: e => colSum(e, 'video_views', 'integer'),
        },
        {
          columnIndex: 9,
          align: 'left',
          formatter: e => colSum(e, 'impressions', 'integer'),
        },
        {
          columnIndex: 10,
          align: 'left',
          formatter: e => colSum(e, 'conversions', 'integer'),
        },
        {
          columnIndex: 11,
          align: 'left',
          formatter: e => colAvg(e, 'clicks'),
        },
        {
          columnIndex: 12,
          align: 'left',
          formatter: e => colAvg(e, 'video_views', 'video_spend'),
        },
        {
          columnIndex: 13,
          align: 'left',
          formatter: e => colAvg(e, 'conversions'),
        },
      ],
    ];

    const table = () => {
      return (
        <BootstrapTable
          exportCSV
          csvFileName={`account-spend-report-${this.state.key}.csv`}
          striped
          ref={`ReportsTable${this.state.key}`}
          data={data || []}
          footerData={footerData}
          footer
          remote
          pagination
          fetchInfo={fetchInfo}
          options={options}
        >
          <TableHeaderColumn width="120" dataSort csvHeader="Date" dataField="day" dataFormat={c => moment(c).local().format('MMMM Do[,] YYYY')}>
            Date
          </TableHeaderColumn>

          <TableHeaderColumn width="120" dataSort csvHeader="Campaign" dataField="campaign_name">
            Campaign
          </TableHeaderColumn>

          <TableHeaderColumn width="75" dataSort csvHeader="Report Type" dataField="report_type" dataFormat={c => c}>
            Type
          </TableHeaderColumn>

          <TableHeaderColumn width="75" dataSort csvHeader="Network" dataField="network_type" dataFormat={c => c}>
            Network
          </TableHeaderColumn>

          <TableHeaderColumn width="75" dataSort csvHeader="$ Click Spend" dataField="spend" dataFormat={c => c}>
            $ Click <br /> Spend
          </TableHeaderColumn>

          <TableHeaderColumn
            width="100"
            dataSort
            csvHeader="$ Video View Spend"
            dataField="video_spend"
            dataFormat={c => c}
            hidden={this.state.key !== 'video'}
          >
            $ Video View <br /> Spend
          </TableHeaderColumn>

          <TableHeaderColumn width="75" csvHeader="$ Total Spend" dataField="total_spend" dataFormat={c => c} hidden={this.state.key !== 'video'}>
            $ Total <br /> Spend
          </TableHeaderColumn>

          <TableHeaderColumn width="75" dataSort csvHeader="Clicks" dataField="clicks" dataFormat={c => c}>
            Clicks
          </TableHeaderColumn>

          <TableHeaderColumn width="75" dataSort csvHeader="Views" dataField="video_views" dataFormat={c => c} hidden={this.state.key !== 'video'}>
            Video <br /> Views
          </TableHeaderColumn>

          <TableHeaderColumn width="100" dataSort csvHeader="Impressions" dataField="impressions" dataFormat={c => c}>
            Impressions
          </TableHeaderColumn>

          <TableHeaderColumn
            width="100"
            dataSort
            csvHeader="Conversions"
            dataField="conversions"
            dataFormat={c => {
              return account.pixel_status === 'pixel_inactive' ? '-' : c;
            }}
          >
            Conversions
          </TableHeaderColumn>

          <TableHeaderColumn width="100" dataSort csvHeader="Average CPC" dataField="acpc" dataFormat={c => c}>
            Avg. CPC
          </TableHeaderColumn>

          <TableHeaderColumn width="100" dataSort csvHeader="Average CPV" dataField="acpv" dataFormat={c => c} hidden={this.state.key !== 'video'}>
            Avg. CPV
          </TableHeaderColumn>

          <TableHeaderColumn
            width="100"
            dataSort
            csvHeader="Average CPA"
            dataField="acpa"
            dataFormat={c => {
              return account.pixel_status === 'pixel_inactive' ? '-' : c;
            }}
          >
            Avg. CPA
          </TableHeaderColumn>

          <TableHeaderColumn isKey hidden width="0" dataField="id" />
        </BootstrapTable>
      );
    };

    return (
      <div className="ibox">
        <div className="ibox-title">
          <div className="ibox-tools row">
            <div className="col-md-4">
              <h5>Account Report</h5>
            </div>
            <div className="col-md-8">
              <div className="form-inline">
                <Select
                  value={get(reports, 'meta.filters.network_type.value', 'all')}
                  options={[
                    { value: 'all', label: 'All' },
                    { value: 'email', label: 'Email' },
                    { value: 'website', label: 'Website' },
                  ]}
                  placeholder="Network type"
                  onChange={e => {
                    const v = { network_type: { value: (e || {}).value, type: 'SelectFilter' } };
                    this.handleOnFilterChange(v);
                  }}
                  className="ibox-tools-select form-group"
                />
                <div className="form-group">
                  <DateRange
                    key="daterange-ad-cu-dash"
                    defaultChosenLabel="This Month"
                    opens="left"
                    startDate={moment(daterange.start_date)}
                    endDate={moment(daterange.end_date)}
                    ranges={calendarRanges}
                    onApply={this.handleDateApply.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`ibox-content${isLoading && summaryIsLoading ? ' sk-loading' : ''}`}>
          <Spinner />
          <div className="row">
            <StatBar label="Total Spend" value={<strong>{summaryIsLoading ? 0 : convertMillsToDollars(reportsSummary.total_spend)}</strong>} />
            <StatBar label="Click Spend" value={<strong>{summaryIsLoading ? 0 : convertMillsToDollars(reportsSummary.total_click_spend)}</strong>} />
            <StatBar
              label="Video View Spend"
              value={<strong>{summaryIsLoading ? 0 : convertMillsToDollars(reportsSummary.total_video_spend)}</strong>}
            />
            <StatBar label="Monthly Budget" value={<strong>{campaignsIsLoading ? 0 : campaignSummary()}</strong>} />
            <StatBar label="Clicks" value={<strong>{summaryIsLoading ? 0 : reportsSummary.total_clicks}</strong>} />
            <StatBar label="Video Views" value={<strong>{summaryIsLoading ? 0 : reportsSummary.total_video_views}</strong>} />
            <StatBar label="Impressions" value={<strong>{summaryIsLoading ? 0 : reportsSummary.total_impressions}</strong>} />
            <StatBar label="Conversions" value={<strong>{summaryIsLoading ? 0 : reportsSummary.total_conversions}</strong>} />
            <StatBar label="Avg. CPC" value={<strong>{summaryIsLoading ? 0 : convertMillsToDollars(reportsSummary.avg_cpc)}</strong>} />
            <StatBar label="Avg. CPV" value={<strong>{summaryIsLoading ? 0 : convertMillsToDollars(reportsSummary.avg_cpv)}</strong>} />
            <StatBar label="Avg. CPA" value={<strong>{summaryIsLoading ? 0 : convertMillsToDollars(reportsSummary.avg_cpa)}</strong>} />
          </div>
          <Tabs activeKey={this.state.key} onSelect={key => this.setState({ key })} id="controlled-tab" style={{ minWidth: 400 }}>
            <Tab unmountOnExit eventKey="text" title="Text Ads" className="p-md">
              {table()}
            </Tab>
            <Tab unmountOnExit eventKey="video" title="Video Ads" className="p-md">
              {table()}
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { advertiser } = state;
  const { account } = ownProps;

  return {
    reports: advertiser.reports.data,
    reportsSummary: advertiser.reportsSummary.data,
    isLoading: advertiser.reports.loading,
    summaryIsLoading: advertiser.reportsSummary.loading,
    campaigns: advertiser.campaigns.data,
    campaignsIsLoading: advertiser.campaigns.loading,
    account,
  };
};

export default connect(mapStateToProps)(CustomDashboard);
